var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "final-timesheet",
      attrs: { "aria-label": "Итоговый табель" }
    },
    [
      _c("portal", { attrs: { to: "task-timesheet-export" } }, [
        _c("div", { staticClass: "sheet-header-actions" }, [
          _c(
            "button",
            {
              staticClass: "custom-btn-secondary",
              attrs: {
                type: "button",
                disabled:
                  _vm.loading || _vm.saving || _vm.stale || !_vm.entries.length
              },
              on: { click: _vm.exportSheet }
            },
            [
              _c("v-icon", { attrs: { name: "buttons/export", size: 12 } }),
              _vm._v(" Экспорт\n      ")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "sheet-help-toggle",
              attrs: {
                type: "button",
                "aria-expanded": _vm.showHelp,
                "aria-controls": "task-timesheet-help",
                "aria-label": "Как работать с табелем"
              },
              on: {
                click: function($event) {
                  _vm.showHelp = !_vm.showHelp
                }
              }
            },
            [
              _c("v-icon", {
                attrs: { name: "buttons/question_circle", size: 14 }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("portal", { attrs: { to: "task-timesheet-actions" } }, [
        _vm.canEdit
          ? _c(
              "button",
              {
                staticClass: "sheet-edit",
                attrs: { type: "button", disabled: _vm.saving },
                on: { click: _vm.toggleEditing }
              },
              [
                _c("v-icon", {
                  attrs: {
                    name: _vm.editing ? "buttons/check" : "buttons/edit",
                    size: 14
                  }
                }),
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.editing
                        ? "Завершить редактирование"
                        : "Редактировать табель"
                    ) +
                    "\n    "
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sheet-toolbar" }, [
        _c(
          "div",
          { staticClass: "sheet-filters" },
          [
            _c(
              "b-dropdown",
              {
                attrs: {
                  "no-caret": "",
                  "toggle-class": "sheet-menu-toggle",
                  variant: "link",
                  "aria-label": "Действия с табелем"
                },
                scopedSlots: _vm._u([
                  {
                    key: "button-content",
                    fn: function() {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "sheet-menu-dots",
                            attrs: { "aria-hidden": "true" }
                          },
                          [_vm._v("…")]
                        ),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Действия с табелем")
                        ])
                      ]
                    },
                    proxy: true
                  }
                ])
              },
              [
                _vm._v(" "),
                _c(
                  "b-dropdown-item",
                  {
                    attrs: {
                      disabled: _vm.loading || _vm.saving || !_vm.filtersReady
                    },
                    on: { click: _vm.reload }
                  },
                  [_vm._v("Обновить отклики")]
                ),
                _vm._v(" "),
                _c(
                  "b-dropdown-item",
                  {
                    attrs: {
                      "aria-expanded": _vm.showHelp,
                      "aria-controls": "task-timesheet-help"
                    },
                    on: {
                      click: function($event) {
                        _vm.showHelp = !_vm.showHelp
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.showHelp
                          ? "Скрыть пояснения"
                          : "Как работать с табелем"
                      )
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-dropdown",
              {
                ref: "filters",
                attrs: {
                  "toggle-class": "sheet-period-toggle",
                  "menu-class": "sheet-filter-menu",
                  variant: "link"
                },
                on: {
                  show: function($event) {
                    _vm.calendarYear = Number(_vm.month.slice(0, 4))
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "button-content",
                    fn: function() {
                      return [
                        _c("span", { staticClass: "sheet-period-label" }, [
                          _vm._v(_vm._s(_vm.periodLabel))
                        ])
                      ]
                    },
                    proxy: true
                  }
                ])
              },
              [
                _vm._v(" "),
                _c(
                  "b-dropdown-form",
                  {
                    on: {
                      submit: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "sheet-calendar",
                        attrs: { "aria-label": "Выбор месяца" }
                      },
                      [
                        _c("div", { staticClass: "sheet-calendar-year" }, [
                          _c(
                            "button",
                            {
                              attrs: {
                                type: "button",
                                "aria-label": "Предыдущий год",
                                disabled: _vm.saving || _vm.calendarYear <= 2000
                              },
                              on: {
                                click: function($event) {
                                  _vm.calendarYear--
                                }
                              }
                            },
                            [_vm._v("‹")]
                          ),
                          _vm._v(" "),
                          _c("strong", [_vm._v(_vm._s(_vm.calendarYear))]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              attrs: {
                                type: "button",
                                "aria-label": "Следующий год",
                                disabled: _vm.saving || _vm.calendarYear >= 2100
                              },
                              on: {
                                click: function($event) {
                                  _vm.calendarYear++
                                }
                              }
                            },
                            [_vm._v("›")]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "sheet-calendar-months" },
                          _vm._l(_vm.monthNames, function(name, index) {
                            return _c(
                              "button",
                              {
                                key: name,
                                class: {
                                  active: _vm.month === _vm.monthValue(index)
                                },
                                attrs: {
                                  type: "button",
                                  disabled: _vm.saving,
                                  "aria-pressed":
                                    _vm.month === _vm.monthValue(index)
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.selectMonth(index)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(name))]
                            )
                          }),
                          0
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Группа заявок",
                          "label-for": "sheet-group"
                        }
                      },
                      [
                        _c("b-form-select", {
                          attrs: {
                            id: "sheet-group",
                            options: _vm.groupOptions,
                            disabled: _vm.saving
                          },
                          on: { change: _vm.reload },
                          model: {
                            value: _vm.groupId,
                            callback: function($$v) {
                              _vm.groupId = _vm._n($$v)
                            },
                            expression: "groupId"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      { staticClass: "mb-0", attrs: { label: "Объект" } },
                      [
                        _c("location-select", {
                          attrs: {
                            value: _vm.locationId,
                            "is-disabled": _vm.saving
                          },
                          on: { onSelect: _vm.selectLocation }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.loading
              ? _c("b-spinner", {
                  staticClass: "text-muted",
                  attrs: { small: "", label: "Обновление табеля" }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "sheet-actions",
            attrs: { "aria-label": "Статусы смен" }
          },
          _vm._l(_vm.statuses, function(status) {
            return _c(
              "span",
              {
                key: status,
                attrs: {
                  title: status === "attended" ? _vm.selectionBlockReason : ""
                }
              },
              [
                _vm.editing
                  ? _c(
                      "button",
                      {
                        staticClass: "sheet-action",
                        class: "status-" + status,
                        attrs: {
                          type: "button",
                          disabled:
                            _vm.saving ||
                            _vm.loading ||
                            _vm.stale ||
                            !_vm.selectedIds.length ||
                            (status === "attended" &&
                              !!_vm.selectionBlockReason)
                        },
                        on: {
                          click: function($event) {
                            return _vm.setAttendance(status)
                          }
                        }
                      },
                      [
                        _c("v-icon", {
                          attrs: {
                            name: _vm.statusIcons[status],
                            color: _vm.statusColors[status],
                            size: 13
                          }
                        }),
                        _vm._v(
                          _vm._s(
                            status === "planned"
                              ? "Запланировать"
                              : _vm.labels[status]
                          ) + "\n        "
                        )
                      ],
                      1
                    )
                  : _c(
                      "span",
                      {
                        staticClass: "sheet-action",
                        class: "status-" + status
                      },
                      [
                        _c("v-icon", {
                          attrs: {
                            name: _vm.statusIcons[status],
                            color: _vm.statusColors[status],
                            size: 13
                          }
                        }),
                        _vm._v(
                          _vm._s(
                            status === "planned"
                              ? "Запланировать"
                              : _vm.labels[status]
                          ) + "\n        "
                        )
                      ],
                      1
                    )
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("b-alert", { attrs: { show: !!_vm.error, variant: "warning" } }, [
        _vm._v(_vm._s(_vm.error))
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sheet-help-collapse",
          class: { "is-open": _vm.showHelp },
          attrs: { id: "task-timesheet-help", "aria-hidden": !_vm.showHelp }
        },
        [_vm._m(0)]
      ),
      _vm._v(" "),
      !_vm.filtersReady
        ? _c(
            "div",
            { staticClass: "sheet-empty-state" },
            [
              _c("v-icon", {
                attrs: { name: "buttons/table_block", size: 32 }
              }),
              _vm._v(" "),
              _c("h5", [_vm._v("Выберите табель")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Укажите месяц и группу заявок или объект в фильтре выше."
                )
              ])
            ],
            1
          )
        : _vm.loading && !_vm.entries.length
        ? _c(
            "div",
            { staticClass: "sheet-empty-state" },
            [
              _c("b-spinner", { attrs: { small: "" } }),
              _vm._v(" Загрузка табеля…")
            ],
            1
          )
        : !_vm.entries.length && !_vm.error
        ? _c("div", { staticClass: "sheet-empty-state" }, [
            _vm._v("За выбранный месяц нет назначенных исполнителей.")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.entries.length
        ? [
            _vm.editing
              ? _c(
                  "div",
                  {
                    staticClass: "sheet-selection",
                    attrs: { "aria-live": "polite" }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.selectedIds.length
                            ? "Выбрано смен: " + _vm.selectedIds.length
                            : "Выберите смены в табеле"
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        attrs: {
                          type: "button",
                          disabled: _vm.saving || _vm.loading || _vm.stale
                        },
                        on: { click: _vm.selectAll }
                      },
                      [_vm._v("Выбрать все")]
                    ),
                    _vm._v(" "),
                    _vm.selectedIds.length
                      ? _c(
                          "button",
                          {
                            attrs: { type: "button", disabled: _vm.saving },
                            on: {
                              click: function($event) {
                                _vm.selectedIds = []
                              }
                            }
                          },
                          [_vm._v("Снять выделение")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("label", { staticClass: "sheet-all-rate" }, [
                      _vm._v("Ставка для всех\n        "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.allRate,
                            expression: "allRate"
                          }
                        ],
                        attrs: {
                          type: "number",
                          min: "0",
                          max: "1000000000",
                          step: "0.01",
                          placeholder: "₽",
                          disabled: _vm.saving || _vm.loading || _vm.stale
                        },
                        domProps: { value: _vm.allRate },
                        on: {
                          focus: function($event) {
                            _vm.rateFocused = true
                          },
                          blur: function($event) {
                            _vm.rateFocused = false
                          },
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.applyAllRate.apply(null, arguments)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.allRate = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        attrs: {
                          type: "button",
                          disabled:
                            _vm.saving ||
                            _vm.loading ||
                            _vm.stale ||
                            _vm.allRate === ""
                        },
                        on: { click: _vm.applyAllRate }
                      },
                      [_vm._v("Применить")]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.editing && _vm.selectionBlockReason
              ? _c(
                  "p",
                  {
                    staticClass: "sheet-block-reason",
                    attrs: { role: "status" }
                  },
                  [_vm._v(_vm._s(_vm.selectionBlockReason))]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "sheet-scroll",
                attrs: {
                  tabindex: "0",
                  role: "region",
                  "aria-label": "Смены исполнителей по дням месяца"
                }
              },
              [
                _c("table", { staticClass: "sheet-table" }, [
                  _c("caption", { staticClass: "sr-only" }, [
                    _vm._v(
                      "Табель: " +
                        _vm._s(_vm.periodLabel) +
                        ". Итоги по сменам со статусом «Вышел»."
                    )
                  ]),
                  _vm._v(" "),
                  _c("thead", [
                    _c(
                      "tr",
                      {
                        staticClass: "sheet-counts",
                        attrs: { "aria-hidden": "true" }
                      },
                      [
                        _c("td", { staticClass: "sheet-number" }),
                        _c("td", { staticClass: "sheet-worker" }),
                        _c("td", { staticClass: "sheet-rate" }),
                        _vm._v(" "),
                        _vm._l(_vm.days, function(day) {
                          return _c("td", { key: day.date }, [
                            _vm._v(
                              _vm._s(
                                _vm.counts[day.date]
                                  ? _vm.counts[day.date] + " чел."
                                  : ""
                              )
                            )
                          ])
                        }),
                        _vm._v(" "),
                        _c("td", {
                          staticClass: "sheet-total sheet-total-days"
                        }),
                        _c("td", {
                          staticClass: "sheet-total sheet-total-units"
                        }),
                        _c("td", {
                          staticClass: "sheet-total sheet-total-amount"
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "tr",
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _vm._m(2),
                        _vm._v(" "),
                        _vm._m(3),
                        _vm._v(" "),
                        _vm._l(_vm.days, function(day) {
                          return _c(
                            "th",
                            {
                              key: day.date,
                              attrs: { scope: "col", "aria-label": day.date }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "sheet-heading sheet-day-heading"
                                },
                                [
                                  _c("span", [_vm._v(_vm._s(day.name))]),
                                  _c("span", [_vm._v(_vm._s(day.number))])
                                ]
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm._m(4),
                        _vm._v(" "),
                        _vm._m(5),
                        _vm._v(" "),
                        _vm._m(6)
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.rows, function(row, index) {
                      return _c(
                        "tr",
                        { key: row.id },
                        [
                          _c("td", { staticClass: "sheet-number" }, [
                            _vm._v(_vm._s(index + 1))
                          ]),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "sheet-worker",
                              attrs: { scope: "row", title: row.name }
                            },
                            [_vm._v(_vm._s(_vm.shortName(row.name)))]
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "sheet-rate" }, [
                            _vm.editing && _vm.rowEditable(row)
                              ? _c("input", {
                                  staticClass: "sheet-rate-input",
                                  attrs: {
                                    type: "number",
                                    min: "0",
                                    max: "1000000000",
                                    step: "0.01",
                                    placeholder:
                                      row.rates.length > 1 ? "Разные" : "",
                                    "aria-label": "Ставка: " + row.name,
                                    disabled:
                                      _vm.saving || _vm.loading || _vm.stale
                                  },
                                  domProps: {
                                    value:
                                      row.rates.length === 1 ? row.rates[0] : ""
                                  },
                                  on: {
                                    focus: function($event) {
                                      _vm.rateFocused = true
                                    },
                                    blur: function($event) {
                                      _vm.rateFocused = false
                                    },
                                    change: function($event) {
                                      return _vm.saveRate(row, $event)
                                    },
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return $event.target.blur()
                                    }
                                  }
                                })
                              : _c(
                                  "span",
                                  {
                                    attrs: {
                                      title: row.rates
                                        .map(_vm.formatNumber)
                                        .join(", ")
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        row.rates.length === 1
                                          ? _vm.formatNumber(row.rates[0])
                                          : "Разные"
                                      )
                                    )
                                  ]
                                )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.days, function(day) {
                            return _c(
                              "td",
                              { key: day.date, staticClass: "sheet-day" },
                              [
                                !row.cells[day.date]
                                  ? _c("span", { staticClass: "sheet-empty" })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(row.cells[day.date] || [], function(
                                  entry
                                ) {
                                  return _c(
                                    "button",
                                    {
                                      key: entry.id,
                                      staticClass: "sheet-shift",
                                      class: [
                                        "status-" + entry.attendance_status,
                                        {
                                          "sheet-selected": _vm.selectedIds.includes(
                                            entry.id
                                          )
                                        }
                                      ],
                                      attrs: {
                                        type: "button",
                                        id: "sheet-shift-" + entry.id,
                                        "aria-label": _vm.entryTitle(entry),
                                        "aria-pressed": _vm.selectedIds.includes(
                                          entry.id
                                        ),
                                        "aria-disabled":
                                          !_vm.editing ||
                                          !entry.can_edit ||
                                          _vm.saving ||
                                          _vm.loading ||
                                          _vm.stale
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.toggleEntry(entry)
                                        }
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            entry.attendance_status ===
                                              "attended"
                                              ? _vm.formatNumber(
                                                  entry.total_units
                                                )
                                              : "\u00a0"
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.indicator(entry)
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "sheet-response",
                                              class: _vm.indicator(entry)
                                                .accepted
                                                ? "response-accepted"
                                                : "response-missing",
                                              attrs: { "aria-hidden": "true" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.indicator(entry).accepted
                                                    ? "✓"
                                                    : "✕"
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _vm._l(row.cells[day.date] || [], function(
                                  entry
                                ) {
                                  return _c(
                                    "b-popover",
                                    {
                                      key: "info-" + entry.id,
                                      attrs: {
                                        target: "sheet-shift-" + entry.id,
                                        triggers: "hover focus",
                                        placement: "auto",
                                        boundary: "viewport",
                                        delay: { show: 120, hide: 180 },
                                        "custom-class":
                                          "timesheet-shift-popover"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "sheet-shift-info" },
                                        [
                                          _c("strong", [
                                            _vm._v(_vm._s(entry.worker_name))
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(entry.date) +
                                                " · Заявка №" +
                                                _vm._s(entry.task_id)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.labels[
                                                  entry.attendance_status
                                                ]
                                              ) +
                                                " · " +
                                                _vm._s(
                                                  _vm.employmentLabel(
                                                    entry.employment_type
                                                  )
                                                )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                entry.work_name ||
                                                  "Работы по заявке"
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.shiftTime(entry.start_date)
                                              ) +
                                                " — " +
                                                _vm._s(
                                                  _vm.shiftTime(entry.end_date)
                                                )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              "Количество: " +
                                                _vm._s(
                                                  _vm.formatNumber(
                                                    entry.total_units
                                                  )
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.unitLabel(entry.unit_code)
                                                )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              "Ставка: " +
                                                _vm._s(
                                                  _vm.formatNumber(entry.price)
                                                ) +
                                                " ₽"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              "Расходы: " +
                                                _vm._s(
                                                  _vm.formatNumber(
                                                    Number(
                                                      entry.road_price || 0
                                                    ) +
                                                      Number(
                                                        entry.meal_cost || 0
                                                      ) +
                                                      Number(
                                                        entry.other_cost || 0
                                                      )
                                                  )
                                                ) +
                                                " ₽; аванс: " +
                                                _vm._s(
                                                  _vm.formatNumber(
                                                    entry.prepaid
                                                  )
                                                ) +
                                                " ₽"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.indicator(entry)
                                            ? _c(
                                                "p",
                                                {
                                                  class: _vm.indicator(entry)
                                                    .accepted
                                                    ? "response-accepted"
                                                    : "response-missing"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.indicator(entry).text
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          entry.can_edit
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "custom-btn-secondary",
                                                  attrs: {
                                                    type: "button",
                                                    disabled:
                                                      _vm.saving ||
                                                      _vm.loading ||
                                                      _vm.stale
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.openWork(entry)
                                                    }
                                                  }
                                                },
                                                [_vm._v("Редактировать")]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "sheet-total sheet-total-days" },
                            [_vm._v(_vm._s(row.days.size))]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "sheet-total sheet-total-units" },
                            [_vm._v(_vm._s(_vm.formatNumber(row.units)))]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "sheet-total sheet-total-amount" },
                            [_vm._v(_vm._s(_vm.formatNumber(row.amount)))]
                          )
                        ],
                        2
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("tfoot", [
                    _c("tr", [
                      _c("td", { attrs: { colspan: _vm.days.length + 3 } }, [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Итого по выходам")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "sheet-total sheet-total-days" },
                        [_c("span", [_vm._v(_vm._s(_vm.totals.days))])]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "sheet-total sheet-total-units" },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.formatNumber(_vm.totals.units)))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "sheet-total sheet-total-amount" },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.formatNumber(_vm.totals.amount)))
                          ])
                        ]
                      )
                    ])
                  ])
                ])
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.tasks.length
        ? _c("div", { staticClass: "sheet-summary" }, [
            _c(
              "div",
              [
                _c("h5", [_vm._v("Итоговые расчёты")]),
                _vm._v(" "),
                _vm._l(_vm.summaryFields, function(field) {
                  return _c("p", { key: field.key }, [
                    _vm._v(_vm._s(field.label) + ": "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.formatNumber(_vm.summary[field.key])) + " ₽"
                      )
                    ])
                  ])
                }),
                _vm._v(" "),
                _c("p", { staticClass: "sheet-summary-note" }, [
                  _vm._v("Расчёт по сменам со статусом «Вышел».")
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "sheet-payment" }, [
              _c(
                "button",
                {
                  staticClass: "custom-btn-primary",
                  attrs: {
                    type: "button",
                    disabled:
                      !_vm.canSubmit ||
                      _vm.saving ||
                      _vm.loading ||
                      _vm.stale ||
                      !!_vm.workEntry ||
                      _vm.allRate !== ""
                  },
                  on: { click: _vm.confirmPayment }
                },
                [_vm._v("На оплату")]
              ),
              _vm._v(" "),
              _vm.paymentBlockReason
                ? _c("p", { staticClass: "sheet-summary-note" }, [
                    _vm._v(_vm._s(_vm.paymentBlockReason))
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.workEntry
        ? _c("task-timesheet-work-modal", {
            key: _vm.workEntry.id,
            attrs: {
              entry: _vm.workEntry,
              saving: _vm.saving,
              error: _vm.workError
            },
            on: { close: _vm.closeWork, save: _vm.saveWork }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sheet-help-content" }, [
      _c("div", { staticClass: "sheet-help" }, [
        _c("p", [
          _vm._v(
            "Нажмите «Редактировать табель», выберите смены и задайте статус. Итоги учитывают только смены со статусом «Вышел»."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _c("span", { staticClass: "response-accepted" }, [_vm._v("✓")]),
          _vm._v(" СМЗ откликнулся в Баланс Про.\n          "),
          _c("span", { staticClass: "response-missing" }, [_vm._v("✕")]),
          _vm._v(" Без отклика перевод в «Вышел» недоступен.")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Отклики обновляются автоматически. Если у исполнителя несколько работ в один день, каждая смена отмечается отдельно."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", { staticClass: "sheet-number", attrs: { scope: "col" } }, [
      _c("span", { staticClass: "sheet-heading" }, [_vm._v("№")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", { staticClass: "sheet-worker", attrs: { scope: "col" } }, [
      _c("span", { staticClass: "sheet-heading" }, [_vm._v("Исполнители")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", { staticClass: "sheet-rate", attrs: { scope: "col" } }, [
      _c("span", { staticClass: "sheet-heading" }, [_vm._v("Ставка")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      { staticClass: "sheet-total sheet-total-days", attrs: { scope: "col" } },
      [
        _c("span", { staticClass: "sheet-heading" }, [
          _vm._v("Кол-во"),
          _c("br"),
          _vm._v("дней")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      { staticClass: "sheet-total sheet-total-units", attrs: { scope: "col" } },
      [
        _c("span", { staticClass: "sheet-heading" }, [
          _vm._v("Кол-во"),
          _c("br"),
          _vm._v("работы")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticClass: "sheet-total sheet-total-amount",
        attrs: { scope: "col" }
      },
      [
        _c("span", { staticClass: "sheet-heading" }, [
          _vm._v("Сумма"),
          _c("br"),
          _vm._v("исполнителю")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57d0939c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57d0939c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasks/TaskFinalTimesheet.vue
// module id = null
// module chunks = 